import CategorySet from './CategorySet';
import CategorySetList from './CategorySetList';
import {CategoryModifiedProvider} from './CategoryModifiedContext';
import { Routes,Route } from 'react-router-dom-v5-compat';
import ProtectedPromotionCampaignRoutes from '../PromotionCampaign'

const Categories = () => {
    return (
        <CategoryModifiedProvider value={false}>
            <Routes>
                <Route path="/categories" element={<CategorySet/>}>
                    <Route path= 'promotion-campaigns/*' element={<ProtectedPromotionCampaignRoutes />} />
                </Route>
                <Route path='/categories/publications'  element={<CategorySet/>} />
                <Route path="/categories/:id" element={<CategorySetList/>} />
            </Routes>
        </CategoryModifiedProvider>
    )
}

export default Categories;
